import { render, staticRenderFns } from "./home.vue?vue&type=template&id=8693127a&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./home.vue?vue&type=custom&index=0&blockType=i18n&lang=json5"
if (typeof block0 === 'function') block0(component)
import block1 from "./home.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports